const state = {
  orderLoaded: false
}

const mutations = {
  'ORDER_LOADING_COMPLETE' (state) {
    state.orderLoaded = true
  }
}

const actions = {
  orderLoadingComplete: ({ commit }) => {
    commit('ORDER_LOADING_COMPLETE')
  }
}

const getters = {
  orderLoaded: state => {
    return state.orderLoaded
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
